import { render } from "./RequestPassword.vue?vue&type=template&id=8c74045e"
import script from "./RequestPassword.vue?vue&type=script&lang=js"
export * from "./RequestPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__